import type { MenuItem, UserRole } from '@/types/menu'

// Presentation only. Keep the complete menu for permissions, history and deep links.
const secondaryFinanceIds = new Set([
  'task-voucher-audit', 'task-refund', 'task-records', 'finance-orders', 'payments',
  'cost-profit', 'prepayments', 'refunds', 'reissue-pending', 'monthly',
])

export function compactFinanceMenu(menus: MenuItem[], roles: UserRole[], viewRole: UserRole | null): MenuItem[] {
  const financeView = roles.includes('ADMIN') ? viewRole === 'FINANCE' : roles.includes('FINANCE')
  if (!financeView) return menus
  return menus.filter(item => !secondaryFinanceIds.has(item.id) || (
    !roles.includes('ADMIN') && item.roles.some(role => role !== 'FINANCE' && roles.includes(role))
  ))
}

export function financeParentMenu(path: string): string | undefined {
  if (['/dashboard/finance/cost-profit', '/dashboard/finance/monthly', '/dashboard/finance/reissue-pending'].some(p => path === p || path.startsWith(p + '/'))) return 'invoices'
  if (['/dashboard/finance/payments', '/dashboard/finance/refunds', '/dashboard/finance/prepayments', '/dashboard/finance/orders', '/dashboard/tasks/voucher-audit', '/dashboard/tasks/refund', '/dashboard/tasks/records'].some(p => path === p || path.startsWith(p + '/'))) return 'task-payment-reconcile'
}
